import AppConfig from './configs/AppConfigs';
import config from './package.json';
import { configReducer } from './reducers/configReducer';
import googleOptimizeABTestReducer from './reducers/googleOptimizeABTestReducer';
import reducerRegistry from '../../registries/ReducerRegistry';
import { ModuleConfig } from '../../types/configTypes';
import { userGroupReducer } from './reducers/userGroupReducer';

const init = () => {
  reducerRegistry.register(AppConfig.moduleName, 'config', {
    reducer: configReducer,
  });
  reducerRegistry.register(AppConfig.moduleName, 'googleOptimizeABTest', {
    reducer: googleOptimizeABTestReducer,
  });
  reducerRegistry.register(AppConfig.moduleName, 'userGroup', {
    reducer: userGroupReducer,
  });
};

init();

export default {
  config,
} as ModuleConfig;
